<div *ngIf="getDays(data.appt_start) >= 2 && data.status=='booked'">
  Appointment was {{getDays(data.appt_start)}} days ago.<br>Mark it Complete or No-Show?
</div>